<template>
  <vs-card>
    <accordion>
      <draggable v-model="categories">
        <accordion-item v-for="category in categories" :key="category.id">
          <template slot="accordion-trigger">
            <vs-button type="flat" size="large" color="#dcdcdc">
              <vs-icon icon="drag_handle" style="margin-left: -30px; margin-right: 10px;"></vs-icon>
              <span style="color: #00420D;">{{ category.name }}</span>
            </vs-button>
            <vs-dropdown>
              <vs-button class="btn-drop" type="flat" size="large" color="#dcdcdc">
                <small style="color: #333;">Items: {{ category.products.length }}</small>
                <vs-icon
                  icon="more_vert"
                  color="#333"
                  style="margin-right: -30px; margin-left: 10px;"
                ></vs-icon>
              </vs-button>
              <vs-dropdown-menu>
                <vs-dropdown-item>
                  Edit
                  <vs-icon icon="pencil"></vs-icon>
                </vs-dropdown-item>
                <vs-dropdown-item>
                  Delete
                  <vs-icon icon="trash"></vs-icon>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </template>
          <template slot="accordion-content">
            <accordion>
              <draggable v-model="category.products">
                <accordion-item
                  v-for="product in category.products"
                  :key="product.id"
                  class="padding-left-1"
                >
                  <template slot="accordion-trigger">
                    <vs-button type="flat" size="large" color="#dcdcdc">
                      <vs-icon icon="drag_handle" style="margin-left: -30px; margin-right: 10px;"></vs-icon>
                      <span style="color: #00420D;">{{ product.name }}</span>
                    </vs-button>
                    <vs-dropdown>
                      <vs-button class="btn-drop" type="flat" size="large" color="#dcdcdc">
                        <small style="color: #333;">Options: {{ product.addon_categories.length }}</small>
                        <small style="color: #333; margin-left: 40px;">€ {{ product.price }}</small>
                        <vs-icon
                          icon="more_vert"
                          color="#333"
                          style="margin-right: -30px; margin-left: 10px;"
                        ></vs-icon>
                      </vs-button>
                      <vs-dropdown-menu>
                        <vs-dropdown-item>
                          Edit
                          <vs-icon icon="pencil"></vs-icon>
                        </vs-dropdown-item>
                        <vs-dropdown-item>
                          Delete
                          <vs-icon icon="trash"></vs-icon>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </template>
                  <template slot="accordion-content">
                    <accordion>
                      <draggable v-model="product.addon_categories">
                        <accordion-item
                          v-for="addon_category in product.addon_categories"
                          :key="addon_category.id"
                          class="padding-left-2"
                        >
                          <template slot="accordion-trigger">
                            <vs-button type="flat" size="large" color="#dcdcdc">
                              <vs-icon
                                icon="drag_handle"
                                style="margin-left: -30px; margin-right: 10px;"
                              ></vs-icon>
                              <span style="color: #00420D;">{{ addon_category.name }}</span>
                            </vs-button>
                            <vs-button class="btn-drop" type="flat" size="large" color="#dcdcdc">
                              <small
                                v-if="addon_category.multiple == 0"
                                style="color: #333; margin-left: 40px;"
                              >Klant selecteert er 1</small>
                              <small
                                v-if="addon_category.multiple == 1"
                                style="color: #333; margin-left: 40px;"
                              >Optioneel</small>
                            </vs-button>
                          </template>
                          <template slot="accordion-content">
                            <accordion>
                              <draggable v-model="addon_category.addons">
                                <accordion-item
                                  v-for="addon in addon_category.addons"
                                  :key="addon.id"
                                  class="padding-left-1"
                                >
                                  <template slot="accordion-trigger">
                                    <vs-button type="flat" size="large" color="#dcdcdc">
                                      <vs-icon
                                        icon="drag_handle"
                                        style="margin-left: -30px; margin-right: 10px;"
                                      ></vs-icon>
                                      <span style="color: #00420D;">{{ addon.name }}</span>
                                    </vs-button>
                                    <vs-button
                                      class="btn-drop"
                                      type="flat"
                                      size="large"
                                      color="#dcdcdc"
                                    >
                                      <small v-if="addon.price == null" style="color: #333;">Gratis</small>
                                      <small v-else style="color: #333;">€ {{ addon.price}}</small>
                                    </vs-button>
                                  </template>
                                </accordion-item>
                              </draggable>
                            </accordion>
                          </template>
                        </accordion-item>
                      </draggable>
                    </accordion>
                  </template>
                </accordion-item>
              </draggable>
            </accordion>
          </template>
        </accordion-item>
      </draggable>
    </accordion>
  </vs-card>
</template>

<script>
import Accordion from "./Accordion.vue";
import draggable from "vuedraggable";
import AccordionItem from "./Accordion-item.vue";

export default {
  name: "ht-menu-list",
  components: {
    Accordion,
    AccordionItem,
    draggable
  },

  data() {
    return {
      categories: [],
      company: null,
      addon_categories: []
    };
  },
  mounted() {
    this.company = JSON.parse(localStorage.getItem("company-selected"));
    this.getCategories(this.company);
    this.$events.listen("company-selected", event => {
      this.company = event;
      this.getCategories(this.company);
      console.log("Tree updated");
    });
    this.$events.listen('company-menu-updated', event => {
      this.$vs.loading.close();
      this.getCategories()
    });
    this.$events.listen("save-company-menu", event => {
      this.saveCategories();
    })
  },
  created() {
    this.company = JSON.parse(localStorage.getItem("company-selected"));
  },
  watch: {
    categories: {
      handler() {
        this.categories.map((category, index) => {
          category.position = index + 1;

          category.products.map((product, index2) => {
            product.position = index2 + 1;

            product.addon_categories.map((addon_category, index3) => {
              addon_category.position = index3 + 1;

              addon_category.addons.map((addon, index4) => {
                addon.position = index4 + 1;
              })
            })
          })
        })
      },
      deep: true
    },
  },
  computed: {
    staffRoute () {
      if(this.$route.meta.staff) {
        if(localStorage.getItem('stafftoken') !== null) {
          return true
        }
      } else {
        if(localStorage.getItem('stafftoken') !== null) {
          return true
        }
        return false
      }
    },
  },
  methods: {
    getCategories: function(company) {
        this.$vs.loading();
        if(company != null) {
          var url = this.staffRoute ? 'https://staffapi.hebtrek.nl/v1/company/'+ company.slug +'/menu' : 'https://companyapi.hebtrek.nl/v1/company/'+ company.slug +'/list'
        } else {
          var url = this.staffRoute ? 'https://staffapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/menu' : 'https://companyapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/list'
        }
        var token = this.staffRoute ? JSON.parse(localStorage.getItem('stafftoken')) : JSON.parse(localStorage.getItem('companytoken'))
        this.$http.get(url, {
          headers: {
            Authorization: "Bearer " + token
          }
        })
        .then(response => {
          if (response.data) {
            this.categories = response.data
            this.$vs.loading.close();
          }
        })
        .catch(error => {});
    },
    saveCategories: function() {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: `Bevestigen`,
        text: 'Weet u zeker dat alle posities van alle opties en producten goed staan?',
        acceptText: 'Accepteren',
        cancelText: 'Annuleren',
        accept: this.updateCategories
      })
    },
    updateCategories: function(categories) {
        this.$vs.loading();
        var url = this.staffRoute ? 'https://staffapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/menu/update' : 'https://companyapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/list/update'
        var token = this.staffRoute ? JSON.parse(localStorage.getItem('stafftoken')) : JSON.parse(localStorage.getItem('companytoken'))
        this.$http.post(url, {categories: this.categories},
        {
          headers: {
            Authorization: "Bearer " + token
          }
        })
        .then(response => {
            console.log("Updated")
            if (response.data) {
                this.$vs.loading.close();
                this.$events.fire('company-menu-updated')
            }
        })
        .catch(error => {});
    }
  }
};
</script>

<style>
.loading-example {
	width: 120px;
	float: left;
	height: 120px;
	box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.05);
	border-radius: 10px;
	margin: 8px;
	transition: all 0.3s ease;
	cursor: pointer;
}

.loading-example:hover {
	box-shadow: 0px 0px 0px 0px rgba(0,0,0,0.05);
	transform: translate(0, 4px);
}

.loading-example h4 {
	z-index: 40000;
	position: relative;
	text-align: center;
	padding: 10px;
}

.loading-example.activeLoading {
	opacity: 0 !important;
	transform: scale(0.5);
}
</style>
